import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingGlobalProperty,
    saveGlobalProperty,
    updateGlobalProperty,
    deleteGlobalProperty,
    pagingExtGlobalProperty,
    saveOrUpdateGlobalProperty,
    markDeleteGlobalProperty
} from 'app/services/GlobalPropertyService';

import { ConceptType } from "app/common/Model/ConceptType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class GlobalPropertyStore {
    listAllGlobalProperty = [];
    searchGlobalProperty = new SearchObject();
    pageGlobalProperty = null;
    selectedGlobalProperty = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteGlobalProperty = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllGlobalProperty = async () => {
        if (this.listAllGlobalProperty?.length) return;
        const searchObjectForAll = {
            pageIndex: 1,
            pageSize: 1000000,
        };
        return await pagingGlobalProperty(searchObjectForAll)
            .then(({ data }) => {
                this.listAllGlobalProperty = data?.content;
            }).
            catch((error) => {
                console.error(error);
                toast.error("Lấy kiểu dữ liệu của khái niệm có lỗi");
            })
    }

    pagingGlobalProperty = () => {
        pagingExtGlobalProperty(this.searchGlobalProperty)
            .then(({ data }) => {
                this.pageGlobalProperty = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchGlobalProperty) => {
        this.searchGlobalProperty = checkSearchObject(this.searchGlobalProperty, searchGlobalProperty);
        this.pagingGlobalProperty();
    }

    handleOpenFormCreateOrEdit = (globalPropertyId) => {
        if (Boolean(globalPropertyId)) {
            updateGlobalProperty({
                property: globalPropertyId
            }).then(({ data }) => {
              
                this.selectedGlobalProperty = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
        } else {
            this.selectedGlobalProperty = new ConceptType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveGlobalProperty = async (globalProperty, { setSubmitting }) => {
        return await saveOrUpdateGlobalProperty(globalProperty)
            .then(() => {
                this.selectedGlobalProperty = null;
                toast.success("Lưu thành công");
                this.pagingGlobalProperty();
                this.handleClosePopup();
            })
            .catch(function (error) {
                console.error(error);
                toast.error("Có lỗi xảy ra");
            })
            .finally(function () {
                setSubmitting(false);
            });
    }

    updateGlobalProperty = async (globalProperty, { setSubmitting }) => {
        return await updateGlobalProperty(globalProperty).then(() => {
            this.selectedGlobalProperty = null;
            toast.success("Cập nhật thành công");
            this.pagingGlobalProperty();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Có lỗi xảy ra");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteGlobalProperty = (globalProperty) => {
        this.selectedGlobalProperty = { property: globalProperty?.property };
        this.openConfirmDeleteGlobalProperty = true;
    }

    handleConfirmDeleteGlobalProperty = () => markDeleteGlobalProperty(this.selectedGlobalProperty?.property).then(() => {
        if (this.searchGlobalProperty?.pageIndex > 1 && this.pageGlobalProperty?.content?.length === 1) {
            this.searchGlobalProperty.pageIndex -= 1;
        }
        toast.success("Lưu thành công");
        this.pagingGlobalProperty();
        this.handleClosePopup();
    }).catch(function (error) {
        console.error(error);
        toast.error("Có lỗi xảy ra");
    })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteGlobalProperty = false;
    }

    resetStore = () => {
        this.searchGlobalProperty = new SearchObject();
        this.pageGlobalProperty = null;
        this.selectedGlobalProperty = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteGlobalProperty = false;
    }
}